import { useRef } from 'react'
import {
  IonButton,
  IonButtons,
  IonHeader,
  IonModal,
  IonToolbar,
} from '@ionic/react'

import { EditBonusForm } from './edit-bonus-form'

import type { LoyaltyBonusRule } from '../../../loyalty/loyalty-bonus.schema'
import type { BonusAvailability } from './types'

type Props = {
  availability: BonusAvailability
  bonus: LoyaltyBonusRule
  disabled?: boolean
  onSubmit: () => void
}
function EditBonusButton({ availability, bonus, disabled, onSubmit }: Props) {
  const modalRef = useRef<HTMLIonModalElement>(null)

  return (
    <>
      <IonButton
        id={`editBonusButton-${bonus.objectId}`}
        color="secondary"
        size="small"
        disabled={disabled}
      >
        Edit
      </IonButton>

      <IonModal
        ref={modalRef}
        trigger={`editBonusButton-${bonus.objectId}`}
        style={{ '--height': 'fit-content' }}
      >
        <IonHeader>
          <IonToolbar>
            <IonButtons slot="start">
              <IonButton
                color="secondary"
                onClick={() => modalRef.current?.dismiss()}
              >
                Cancel
              </IonButton>
            </IonButtons>
          </IonToolbar>
        </IonHeader>
        <div className="ion-padding bg-ion-background-color">
          <div className="border-ion-color-secondary mt-3 space-y-2 rounded-lg border bg-white px-3 py-2">
            <div className="flex items-center justify-between">
              <p className="font-semibold">Bonus</p>
            </div>
            <EditBonusForm
              availability={availability}
              bonus={bonus}
              onSubmit={() => {
                onSubmit()
                modalRef.current?.dismiss()
              }}
            />
          </div>
        </div>
      </IonModal>
    </>
  )
}

export { EditBonusButton }
